import React from 'react';

const HowItWorks = ({ data }) => {
  if (!data) return null;

  return (
    <section className="bg-white py-sp-100 sm:py-sp-big">
      <div className="container px-3">
        <div className="text-center mb-6 sm:mb-8">
          {data.heading && (
            <h2 className="text-[#2C2C2C] text-xxxl sm:text-lg font-medium mx-auto mb-3">
              {data.heading}{' '}
              {data.boldHeading && (
                <strong className="font-bold text-[#072F5F]">{data.boldHeading}</strong>
              )}
            </h2>
          )}
          {data.description && (
            <p className="text-[#475569] text-base2 sm:text-sm mx-auto">
              {data.description}
            </p>
          )}
        </div>

        <div className="flex flex-wrap gap-2">
          {data.steps?.map((step) => (
            <div key={step.id} className="w-[23.5%] sm:w-full flex">
              <div className="w-full bg-white border border-[#E2E8F0] rounded-2xl p-3 sm:p-3 flex flex-col justify-start">
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-[#022B5C] to-[#0052CC] transition-all duration-300 transform text-white flex items-center justify-center font-bold text-sm mb-2 shrink-0">
                  {step.stepNumber}
                </div>
                <h3 className="text-brand font-medium text-base mb-1">
                  {step.title}
                </h3>
                <p className="text-[#6F6F6F] text-sm font-normal">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
